import React, { useEffect, useState } from 'react';
import Container from "react-bootstrap/Container";
import Row from "react-bootstrap/Row";


// animtion dark and light
import * as colors from "../../assets/css/Colors";
import { Col } from 'react-bootstrap';
import { Link } from 'react-router-dom';
import Image_png from '../../components/Image_png';
import './app.css';
import Image_webp from '../../components/Image_webp';

const AboutApp = () => {


 // Start color change auto function
 const [colorScheme, setColorScheme] = useState(
    window.matchMedia('(prefers-color-scheme: dark)').matches ? 'dark' : 'light'
  );
  useEffect(() => {
    const mediaQuery = window.matchMedia('(prefers-color-scheme: dark)');
    const handleChange = (e) => {
      setColorScheme(e.matches ? 'dark' : 'light');
    };
    mediaQuery.addEventListener('change', handleChange);
    return () => {
      mediaQuery.removeEventListener('change', handleChange);
    };
  }, []);
// End color change auto function

// language Translate function end
  return (
    <section style={{ backgroundColor: colorScheme === 'dark' ? colors.theme_black_color_bg : colors.theme_white_color_bg }} className='app-download'>
    <div className="str">
       <Container>
            <Row>
<Col sm={6}>
<div>
  <h2>Download Do Digitals App</h2>
  <p>Lorem ipsum dolor sit amet, consectetur adipiscing elit.</p>
  <div className='app-icon-button'>
   <Link to='/'>
   <Image_png text={'play-store'} /> 
   GET IT ON 
   <span>
   Google Play
   </span>
   </Link>
   <Link to='/'>
   <Image_png text={'apple-store'} /> 
   Download on the 
   <span>
   Apple Store
   </span>
   </Link>
  </div>
</div>
</Col>
<Col sm={6}>
<div className='mobile-app-image'>
  <Image_webp text={'mobile-phone'} />
</div>
</Col>
                </Row>
            </Container>
    </div>
</section>
  )
}

export default AboutApp